import { ReactComponent as TrophySvg } from "../../assets/images/svgs/trophy.svg";

const TrophyIcon = ({ className = "", ...props }) => {
  return (
    <TrophySvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default TrophyIcon;
